import React, { useContext } from "react";
import { ProductContext } from "../../provider";

function CanvasScrollLock(): JSX.Element {
  const { productType } = useContext(ProductContext);

  return (
    <>
      {(productType === "kids" ||
        productType === "words" ||
        productType === "ape-maia" ||
        productType === "vintage") && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      )}
      {(productType == "only-image" || productType == "pop-art") && (
        <>
          <div
            style={{
              position: "absolute",
              width: 50,
              height: "100%",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          />
          <div
            style={{
              position: "absolute",
              width: 50,
              height: "100%",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          />
        </>
      )}
    </>
  );
}

export default CanvasScrollLock;
